module.exports = __webpack_public_path__ + "img/1476324001.9f2b794a.jpg";